import { useRef, useState } from "react";

export const useImageUploader = ({ save, remove }) => {
    const [preview, setPreview] = useState(null);
    const inputRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleSelectImage = (e) => {
        const [file] = e.target.files;
        const _preview = URL.createObjectURL(file);

        save(file);
        setPreview(_preview);
    };

    const handleOpenModal = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const handleUnSelectImage = () => {
        remove();
        setPreview(null);
        inputRef.current?.form.reset();
    };

    const handleOpenSelect = () => {
        inputRef.current?.click();
    };

    return {
        preview,
        inputRef,
        open,
        handleSelectImage,
        handleUnSelectImage,
        handleOpenSelect,
        handleOpenModal,
        onClose
    }
}